(function () {
  // Ejecutar solo en escritorio
  const mqDesktop = window.matchMedia('(min-width: 1024px)');
  if (!mqDesktop.matches) return;

  // Espera robusta
  const waitFor = (testFn, cb, { interval = 100, timeout = 5000 } = {}) => {
    const t0 = Date.now();
    const id = setInterval(() => {
      if (testFn()) { clearInterval(id); cb(); }
      else if (Date.now() - t0 > timeout) { clearInterval(id); }
    }, interval);
  };

  // Inyecta CSS (para escritorio)
  const injectCSS = () => {
    if (document.getElementById('pb-chips-css')) return;
    const css = `
      .pb-chips > summary{display:none!important;}
      .pb-chips .facets__display{display:block!important;position:static!important;box-shadow:none!important;border:none!important;padding:0!important;}
      .pb-chips .facets__header,.pb-chips .facets__selected{display:none!important;}
      .pb-chips .facets__list{display:flex!important;flex-wrap:wrap!important;gap:12px!important;padding:0!important;margin:0!important;}
      .pb-chips .facets__item{list-style:none!important;margin:0!important;}
      .pb-chips label.facet-checkbox{display:inline-flex!important;align-items:center;gap:8px;padding:10px 16px;border:1px solid var(--color-borders-main);border-radius:999px;background:transparent;color:var(--color-text-main);line-height:1;white-space:nowrap;max-width:100%;overflow:hidden;text-overflow:ellipsis;cursor:pointer;transition:background .2s,color .2s,border-color .2s,transform .1s;}
      .pb-chips label.facet-checkbox:hover{transform:translateY(-1px);}
      .pb-chips label.facet-checkbox>input[type="checkbox"]{position:absolute!important;opacity:0!important;pointer-events:none!important;}
      .pb-chips label.facet-checkbox:has(> input[type="checkbox"]:checked){background:var(--color-accent-main);color:var(--color-foreground-accent-main);border-color:var(--color-accent-main);}
      @media (max-width:640px){.pb-chips label.facet-checkbox{padding:8px 12px}.pb-chips .facets__list{gap:8px!important}}
      .active-facets.pb-only-clear > *:not(.pb-clear){display:none!important;}
    `;
    const style = document.createElement('style');
    style.id = 'pb-chips-css';
    style.textContent = css;
    document.head.appendChild(style);
  };

  // Mejora el facet de Beneficios
  const enhance = () => {
  // Localiza el facet por el name del filtro, no por el texto visible
  const allDetails = Array.from(document.querySelectorAll('details.facets__disclosure'));
  const facet = allDetails.find(d =>
    d.querySelector('input[name="filter.p.m.custom.categorias_capsulas"]')
  );
  if (!facet) return;

    const list = facet.querySelector('.facets__list');
    if (!list || !list.children.length) return;

    facet.classList.add('pb-chips');
    facet.setAttribute('open', '');

    const active = document.querySelector('.active-facets');
    if (active) {
      active.classList.add('pb-only-clear');
      const clear = Array.from(active.querySelectorAll('a,button'))
        .find(el => /borrar\s+todo/i.test(el.textContent||''));
      if (clear) clear.classList.add('pb-clear');
    }
  };

  // Inicializa y re-aplica en re-renders
  const init = () => waitFor(
    () => document.querySelector('details.facets__disclosure summary'),
    () => { injectCSS(); enhance(); }
  );

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
  const mo = new MutationObserver(() => enhance());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', () => {
  const mqDesktop = window.matchMedia('(min-width: 1024px)');
  if (!mqDesktop.matches) return;

  const cleanNumbers = () => {
    const labels = document.querySelectorAll('.pb-chips label.facet-checkbox');
    labels.forEach(label => {
      label.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent.replace(/\s*\(\d+\)\s*/g, '');
        }
      });
    });
  };

  cleanNumbers();

  const mo = new MutationObserver(() => cleanNumbers());
  mo.observe(document.body, { childList: true, subtree: true });
});

/* === PB · Cápsulas · Botón "Ver productos" cierra el drawer móvil === */
document.addEventListener('click', (event) => {
  // Detecta si el clic fue sobre el botón "Ver productos"
  const btn = event.target.closest('.pb-ver-productos');
  if (!btn) return; // Si no es el botón, no hace nada

  // Busca el drawer lateral derecho
  const sidebar = document.querySelector('.sidebar.sidebar--right');
  if (!sidebar) return;

  // Cierra el drawer si está abierto
  if (sidebar.classList.contains('sidebar--opened')) {
    sidebar.classList.remove('sidebar--opened');
    sidebar.classList.add('sidebar--closed');
  }

  // Opcional: elimina foco o resalta el clic
  btn.blur();
});
